import React from 'react';
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import MovieIcon from '@material-ui/icons/Movie';
import { CustomReactPlayer } from '../../../views/common/ReactPlayer';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    padding: '0 8px',
  },
  placeholder: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    color: '#98A2B3',
  },
  title: {
    marginBottom: 8,
    fontWeight: 600,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
});

const VimeoVideoPreview = ({ video }) => {
  const classes = useStyles();

  if (!video) {
    return (
      <div className={classes.root}>
        <div className={classes.placeholder}>
          <MovieIcon style={{ fontSize: 48, marginBottom: 16 }} />
          <Typography variant="body2" style={{ fontSize: 14 }}>
            Select a video to preview
          </Typography>
        </div>
      </div>
    );
  }

  return (
    <div className={classes.root}>
      <Typography variant="subtitle2" className={classes.title}>
        {video.title}
      </Typography>
      <CustomReactPlayer
        url={video.videoUrl}
        width="100%"
        height="200px"
        onError={() => {}}
      />
    </div>
  );
};

export default VimeoVideoPreview;
